/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Search_Action_Start_MetaInputs */

const en_us2_search_action_start_meta = /** @type {(inputs: Search_Action_Start_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercise`);
	return /** @type {LocalizedString} */ (`${i?.count} exercises`)
	
};

const pt_br2_search_action_start_meta = /** @type {(inputs: Search_Action_Start_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios`)
	
};

const es_419_search_action_start_meta = /** @type {(inputs: Search_Action_Start_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 ejercicio`);
	return /** @type {LocalizedString} */ (`${i?.count} ejercicios`)
	
};

const pt_pt2_search_action_start_meta = /** @type {(inputs: Search_Action_Start_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercício`);
	return /** @type {LocalizedString} */ (`${i?.count} exercícios`)
	
};

const fr_fr2_search_action_start_meta = /** @type {(inputs: Search_Action_Start_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 exercice`);
	return /** @type {LocalizedString} */ (`${i?.count} exercices`)
	
};

const de_de2_search_action_start_meta = /** @type {(inputs: Search_Action_Start_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Übung`);
	return /** @type {LocalizedString} */ (`${i?.count} Übungen`)
	
};

const it_it2_search_action_start_meta = /** @type {(inputs: Search_Action_Start_MetaInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 esercizio`);
	return /** @type {LocalizedString} */ (`${i?.count} esercizi`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 exercise" |
* | * | "{count} exercises" |
*
* @param {Search_Action_Start_MetaInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_action_start_meta = /** @type {((inputs: Search_Action_Start_MetaInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Action_Start_MetaInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_action_start_meta(inputs)
	if (locale === "es-419") return es_419_search_action_start_meta(inputs)
	if (locale === "pt-PT") return pt_pt2_search_action_start_meta(inputs)
	if (locale === "fr-FR") return fr_fr2_search_action_start_meta(inputs)
	if (locale === "de-DE") return de_de2_search_action_start_meta(inputs)
	if (locale === "it-IT") return it_it2_search_action_start_meta(inputs)
	return en_us2_search_action_start_meta(inputs)
});
export { search_action_start_meta as "search.action_start_meta" }